"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitCustomDomain = exports.saveDestinationUrl = exports.getCustomDomain = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _utils = require("../utils");

var BASE_URL = '/community/settings';
/**
 * Save/update destination URL
 */

var saveDestinationUrl = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url) {
    var response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _axios.default.post("".concat(BASE_URL, "/save"), {
              destinationURL: url
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            (0, _utils.logError)('saveDestinationUrl', _context.t0);
            throw new Error((0, _utils.handleApiError)(_context.t0, 'Failed to save destination URL'));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function saveDestinationUrl(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Get custom domain information
 */


exports.saveDestinationUrl = saveDestinationUrl;

var getCustomDomain = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var response;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return _axios.default.get('/custom-domain');

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            throw new Error((0, _utils.handleApiError)(_context2.t0, 'Failed to fetch custom domain'));

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function getCustomDomain() {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Generate unique request hash using base64 encoded timestamp
 */


exports.getCustomDomain = getCustomDomain;

var generateRequestHash = function generateRequestHash() {
  var timestamp = Date.now().toString();
  return btoa(timestamp);
};
/**
 * Submit a custom domain for validation and setup
 */


var submitCustomDomain = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(customDomain) {
    var reqHash, response;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            reqHash = generateRequestHash();
            _context3.next = 4;
            return _axios.default.post('/custom-domain', {
              custom_domain: customDomain,
              req_hash: reqHash
            });

          case 4:
            response = _context3.sent;
            return _context3.abrupt("return", {
              response: response.data,
              reqHash: reqHash
            });

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            (0, _utils.logError)('submitCustomDomain', _context3.t0);
            throw new Error((0, _utils.handleApiError)(_context3.t0, 'Failed to submit custom domain'));

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  return function submitCustomDomain(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

exports.submitCustomDomain = submitCustomDomain;